import React from 'react';
import { LOCALE_DISPLAY, SUPPORTED_LOCALES, SupportedLocale } from '@/i18n/index';
import { useLocale } from '@/contexts/LocaleContext';

const FooterLocaleSwitcher = () => {
  let currentLocale: SupportedLocale = 'en-US';
  let setLocale: ((locale: SupportedLocale) => void) | null = null;

  try {
    const ctx = useLocale();
    currentLocale = ctx.currentLocale;
    setLocale = ctx.setLocale;
  } catch {
    return null;
  }

  if (!setLocale) return null;

  const handleSelect = setLocale;

  return (
    <div className="border-t border-brand-ink-foreground/10 pt-6 mt-6">
      <div className="flex flex-wrap gap-x-4 gap-y-2 justify-center md:justify-start">
        {SUPPORTED_LOCALES.map((locale) => {
          const d = LOCALE_DISPLAY[locale];
          const isActive = currentLocale === locale;
          return (
            <button
              key={locale}
              onClick={() => handleSelect(locale)}
              className={`text-xs transition-colors ${
                isActive
                  ? 'text-brand-ink-foreground font-semibold underline underline-offset-2'
                  : 'text-brand-ink-foreground/70 hover:text-brand-ink-foreground'
              }`}
            >
              {d.language}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FooterLocaleSwitcher;
